import React from 'react'
import PropTypes from 'prop-types'
function SolidButton (props) {
  const { type, className, onClick, children, isSecondary, isDisabled } = props

  const selectedColor = !isSecondary ? 'primary-background-1-100' : 'primary-background-2-100'

  if(isDisabled){
    return (
      <button className={`of-solid-button of-solid-button--disabled ${className ? ' ' + className : ''}`} onClick={e=>{e.preventDefault()}}>{children}</button>
    )
  }

  if (type && type === 'submit') {
    return (
      <button className={`of-solid-button${className ? ' ' + className : ''} ${selectedColor}`} type='submit'>{children}</button>
    )
  }
  return (<button onClick={onClick} type='button' className={`of-solid-button${className ? ' ' + className : ''} ${selectedColor}`}>{children}</button>)
}

SolidButton.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.any,
  isSecondary: PropTypes.bool,
  isDisabled: PropTypes.bool
}

export default SolidButton
